jQuery(function($){
    $('.overview-trigger').on("click", function (event) {
        event.preventDefault();

        $('#overviewDisplayContent').empty();
        $('#overviewDisplayContent').append($(event.currentTarget).children('#overviewContent').html());
        $('#overviewModal').removeClass('hidden');
        $('#overviewModal').addClass('flex');
        $('#overviewModal').addClass('flex-col');
    });

    $('#overviewModalClose').on( "click", function() {
        $('#overviewModal').removeClass('flex');
        $('#overviewModal').removeClass('flex-col');
        $('#overviewModal').addClass('hidden');
        $('#overviewDisplayContent').empty();
    });
    
    $('#overviewModal').on( "click", function() {
        $('#overviewModal').removeClass('flex');
        $('#overviewModal').removeClass('flex-col');
        $('#overviewModal').addClass('hidden');
        $('#overviewDisplayContent').empty();
    });
  });